<template>
    <div class="flex">
        <div clas="pl-2">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn small text icon v-bind="attrs" v-on="on" class="gridbutton mt-5">
                    <v-icon medium color="blue">mdi-information-variant</v-icon>
                </v-btn>                
            </template>
            <span>
                <div>
                    This mail will be sent to: 
                </div>
                <div v-if="updatedContacts.length !== 0">
                <tr v-for="(contact, index) in updatedContacts" :key="index">
                    <td class="pr-3">{{ contact.role }}</td>
                    <td class="pr-3">{{ contact.name }}</td>
                    <td>{{ contact.email }}</td>                    
                </tr>
            </div>
            <div v-else>
                (no recipients selected)
            </div>
            </span>
        </v-tooltip> 
        </div> 
        <div class="pl-2">
            <select_ares_language :isDense="false" :selected_language="mail_language" field="mail_language" :ares_languages="getAresLanguages()" label="Mail language" @updateData="updateData"/>
        </div>      
    </div>
</template>

<script>
import select_ares_language from '@/components/ui/selectors/select_ares_language.vue'
export default {
    watch:{
        updatedContacts: {            
            handler(){
                this.getLikelyMailLanguage();
            } 
        },
    },    
    props: {
        huov_encrid:{
            type: String,
            default: ''
        },
        selected_contacts: {
            type: Array,
            default: function() { return []; },
        },      
    },
    components: {
        select_ares_language
    },
    computed: {  // Dit is traaaaaaag....
        updatedContacts: function(){     
            return this.hocts.filter((contact) => {
                return this.checkForOccurence(this.selected_contacts, contact.code) !== 0;
            })
        },    
    },                    
    data() {
        return {
            hocts: [],
            nl:0,
            de:0,
            fr:0,
            en:0,
            mail_language: '',
        }
    },
    created() {
        this.getHoctRecords();
    },
    methods: {
        getLikelyMailLanguage(){
            this.resetLanguages();
            this.hocts.forEach(contact => {
                if(this.checkForOccurence(this.selected_contacts, contact.code) !== 0){
                    this.setLanguage(contact.taalcode);
                }
            })
            this.mail_language = this.getMaxLanguage();
        },
        resetLanguages(){
            this.en=0;
            this.fr=0;
            this.nl=0;
            this.de=0;
        },
        getMaxLanguage(){
            let max = 'EN'; // default = EN
            let maxn = 0;
            if(this.fr > maxn){
               maxn = this.fr;
               max = "FR";
            }
            if(this.en > maxn){
               maxn = this.en;
               max = "EN";            
            }
            if(this.nl > maxn){
               maxn = this.nl;
               max = "NL"            
            }
            if(this.de > maxn){
               maxn = this.de;
               max = "DE";            
            }
            return max;
        },
        setLanguage(lng){
            switch(lng){
               case 'EN':
                  this.en++;
                  break;
               case 'FR':
                  this.fr++;
                  break;
               case 'DE':
                  this.de++;
                  break;
               default:
                  this.nl++;    
            }
            console.log('nl, en, fr, de', this.nl, this.en, this.fr, this.de);
        },
        checkForOccurence(arr, val){
            return arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
        },
        getAresLanguages() {
            return [
                {code: 'EN', description: 'English'},
                {code: 'NL', description: 'Dutch'},
                {code: 'FR', description: 'French'},
                {code: 'DE', description: 'German'},
            ];
        },      
        updateData(data){
            this[data.field] = data.value;  // set the local value
            this.$emit('updateData', data); // pass it back to the parent
        },       
        getHoctRecords() {
            this.$axios
                .post("ares/json/ares/huov/getHoct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHoct"
                    },
                    getHoct: {
                        huov_encrid: this.huov_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error.message);
                    } else {
                        this.hocts = res.data.getHoct;
                    }
                })
        },        
    }
}
</script>

<style scoped>
.flex{
    display: flex;
    flex-direction: row;
}
.gridbutton:hover{
    border: 1px solid rgba(169, 169, 169, 1) !important;
}
</style>